export default function LinkedinIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M0 2.21921C0 1.26997 0.789019 0.5 1.76237 0.5H22.2376C23.2109 0.5 24 1.26997 24 2.21921V22.7808C24 23.7303 23.2109 24.5 22.2376 24.5L1.76237 24.5C0.789019 24.5 0 23.7303 0 22.7808V2.21921ZM7.41507 20.5905V9.75314H3.81294V20.5905H7.41507ZM5.61399 8.27349C6.87012 8.27349 7.65196 7.4413 7.65196 6.40131C7.62855 5.3379 6.87013 4.52881 5.63782 4.52881C4.40564 4.52881 3.6 5.3379 3.6 6.40131C3.6 7.4413 4.38167 8.27349 5.59051 8.27349H5.61399ZM12.9771 20.5905V14.5385C12.9771 14.2146 13.0005 13.891 13.0956 13.6594C13.356 13.0123 13.9487 12.3421 14.9438 12.3421C16.2473 12.3421 16.7687 13.3359 16.7687 14.7928V20.5905H20.3705V14.3765C20.3705 11.0478 18.5934 9.49884 16.2235 9.49884C14.3127 9.49884 13.4559 10.549 12.9772 11.2875V11.3248H12.9531C12.9611 11.3125 12.9691 11.3 12.9772 11.2875V9.75314H9.3751C9.42237 10.77 9.3751 20.5905 9.3751 20.5905H12.9771Z"
        fill="#8897AE"
      />
    </svg>
  );
}
